import type { SaProfile } from '@sellokart/shared';
import type { AuthState } from '@/auth/createAuthPortal';
import { createAuthPortal } from '@/auth/createAuthPortal';
import { api } from '@/lib/api';
import { saSession } from '@/lib/session';

export type AuthContextValue = AuthState<SaProfile>;

/** Super-admin session (`aud: sa`) — the /cp/* console only. Paths below are API endpoints. */
const saPortal = createAuthPortal<SaProfile>({
  name: 'Sa',
  session: saSession,
  client: api,
  loginPath: '/admin/login',
  logoutPath: '/admin/logout',
  // Every /admin query family: tenant records, the audit browser and the
  // platform sync-health screen all leave the cache when the SA signs out.
  queryKeyPrefixes: [['tenants'], ['audit'], ['sync-health']],
});

export const AuthProvider = saPortal.Provider;
export const useAuth = saPortal.useAuth;
